import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    redirect: 'LoginCiudadania',
    children: [
      {
        path: '',
        name: 'LoginCiudadania',
        component: () => import('../components/LoginCiudadania.vue')
      },
      {
        path: 'local',
        name: 'LoginLocal',
        component: () => import('../components/LoginLocal.vue')
      },
    ]
  },
  {
    path: '/inicio',
    name: 'Template',
    component: () => import('../components/Template.vue'),
    redirect: 'Home',
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('../components/Home.vue'),
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/redirect/module/:id',
    name: 'RedirectModule',
    component: () => import('../components/RedirectModule.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '*',
    component: () => import('../views/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    var token = localStorage.getItem('mjti_token')
    var tipo = localStorage.getItem('mjti_tipo')
    if (token == null) {
      if(tipo=== null || JSON.parse(tipo) ==='ciudadania'){
        next('/')
      }else{
        next('/local')
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
